export default "__VITE_ASSET__Bc3$5$6e__"